var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgParking = function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21.9",
    style: {
      enableBackground: "new 0 0 20 21.9"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 17.3c-.6 0-1-.4-1-1V7c0-1.4 1.2-2.4 2.6-2.4h3.4c1.3 0 2.4 1 2.5 2.3v4.2c-.1 1.4-1.3 2.4-2.6 2.3H10c-.6 0-1-.4-1-1s.4-1 1-1h1.7c.3 0 .5-.1.5-.4V7c0-.2-.3-.4-.5-.3H8.3c-.2-.1-.4.1-.5.3v9.2c0 .6-.4 1-1 1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 21.9H4.6c-2.5 0-4.6-2.1-4.6-4.6V4.6C0 2.1 2.1 0 4.6 0h10.8C17.9 0 20 2.1 20 4.6v12.7c0 2.5-2.1 4.6-4.6 4.6zM4.6 2C3.2 2 2 3.2 2 4.6v12.7c0 1.4 1.2 2.6 2.6 2.6h10.8c1.4 0 2.6-1.2 2.6-2.6V4.6C18 3.2 16.8 2 15.4 2H4.6z"
  })));
};
export default SvgParking;